import { TriState } from '@shared/clientTypes/misc';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
import InputLabel from '../Inputs/InputLabel';

type TriStateToggleProps = {
  title: string;
  options: { label: string; value: TriState }[];
  value?: boolean | TriState;
  onChange: (value: TriState) => void;
  className?: string;
  isInactive?: boolean;
};

const TriStateToggle = (props: TriStateToggleProps) => {
  const { title, options, value, onChange, className, isInactive } = props;

  let triStateValue: TriState;
  if (typeof value === 'boolean') {
    triStateValue = value ? 'checked' : 'unchecked';
  } else if (value) {
    triStateValue = value;
  } else {
    triStateValue = 'indeterminate';
  }

  const toggleHandler = (optionValue: TriState) => {
    if (!isInactive) {
      onChange(optionValue);
    }
  };

  return (
    <div className={mergeClassNames('flex flex-col', className)}>
      {title && <InputLabel className="text-white" label={title} />}
      <div className="flex">
        {options.map(({ label, value }, index) => (
          <button
            key={value}
            onClick={() => toggleHandler(value)}
            className={mergeClassNames(
              'py-1.5 px-3 text-xs transition-colors duration-300 text-nowrap border-y border-zinc-500 focus:outline-none',
              {
                'bg-zinc-300 text-zinc-800': triStateValue === value,
                'bg-zinc-800 text-zinc-300': triStateValue !== value,
                'cursor-pointer hover:bg-zinc-500': !isInactive,
                'cursor-not-allowed opacity-50': isInactive,
                'rounded-s-full border-x': index === 0,
                'rounded-e-full border-x': index === options.length - 1,
              }
            )}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TriStateToggle;
